import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ActivitiesService } from './activitiesApi';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { IActivitiesListState } from '../../../../interfaces/activities/IActivitiesListState';
import { PaginatedActivities } from '../../../../interfaces/activities/paginatedStore.type';

const initialState: IActivitiesListState = {
    activitiesAreLoading: false,
    activityIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchAllActivities = createAsyncThunk<any, undefined | null>(
    'activities/tryToFetchAllActivities',
    async () => {
        const result = await ActivitiesService.tryToFetchAllActivities();
        return result?.data;
    }
);

export const tryToFetchActivities = createAsyncThunk<PaginatedActivities, IPaginationPayload>(
    'activities/tryToFetchActivities',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await ActivitiesService.tryToFetchActivities(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);

export const tryToFetchSingleActivity = createAsyncThunk<any, string>(
    'activities/tryToFetchSingleActivity',
    async (id) => {
        const result = await ActivitiesService.tryToFetchSingleActivity(id);
        return result?.data;
    }
);

export const activitiesSlice = createSlice({
    name: 'activities',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchAllActivities
            .addCase(tryToFetchAllActivities.pending, (state) => {
                state.activitiesAreLoading = true;
            })
            .addCase(tryToFetchAllActivities.rejected, (state) => {
                state.activitiesAreLoading = false;
            })
            .addCase(tryToFetchAllActivities.fulfilled, (state, action) => {
                state.activitiesAreLoading = false;
                state.allActivities = action.payload;
            })

            // tryToFetchActivities
            .addCase(tryToFetchActivities.pending, (state) => {
                state.activitiesAreLoading = true;
            })
            .addCase(tryToFetchActivities.rejected, (state) => {
                state.activitiesAreLoading = false;
            })
            .addCase(tryToFetchActivities.fulfilled, (state, action) => {
                state.activitiesAreLoading = false;
                state.activities = action.payload;
            })

            // tryToFetchSingleActivity
            .addCase(tryToFetchSingleActivity.pending, (state) => {
                state.activityIsLoading = true;
            })
            .addCase(tryToFetchSingleActivity.rejected, (state) => {
                state.activityIsLoading = false;
            })
            .addCase(tryToFetchSingleActivity.fulfilled, (state, action) => {
                state.activityIsLoading = false;
                state.activity = action.payload;
            })

    },
});

export default activitiesSlice.reducer;